/**
 * Renders a warning/error tag for shipment exceptions (e.g. late, redirected).
 */

import React from "react"
import PropTypes from "prop-types"
import Tag from "@amzn/meridian/tag"
import { getExceptionById } from "../../data/exceptions"
import incomingShipmentPropType from "../../prop-types/incoming-shipment"

const ExceptionTag = props => {
  const exception = getExceptionById(props.shipment.exceptionId)
  if (!exception) return null
  return (
    <>
      {props.children}
      <Tag type={exception.type} key={exception.id}>
        {exception.label}
      </Tag>
    </>
  )
}

ExceptionTag.propTypes = {
  shipment: incomingShipmentPropType.isRequired,
  children: PropTypes.node,
}

export default ExceptionTag
